import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.333 16c0-7.363-5.97-13.333-13.334-13.333C8.636 2.667 2.666 8.637 2.666 16c0 7.364 5.97 13.334 13.333 13.334 7.364 0 13.334-5.97 13.334-13.334zM14.846 9.715a1.914 1.914 0 113.829 0 1.914 1.914 0 01-3.829 0zm-1.714 5.143c0-.742.601-1.343 1.343-1.343h2.286a1.344 1.344 0 011.29 1.705l-1.791 6.295h.5a1.343 1.343 0 010 2.686h-2.285a1.344 1.344 0 01-1.29-1.706l1.79-6.294h-.5a1.343 1.343 0 01-1.343-1.343z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
